import {CloseX} from '@baidu/luffy-comp-close-x';
export default CloseX;
